var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c("div", { attrs: { id: "container" } }),
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQueryCus($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["factory"] } },
                        [
                          _c("a-select", {
                            attrs: {
                              showSearch: "",
                              optionFilterProp: "children",
                              options: _vm.factoryOptions,
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["factory"],
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.factoryId,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "factoryId", $$v)
                              },
                              expression: "queryParam.factoryId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["legalperson"] } },
                        [
                          _c("a-select", {
                            attrs: {
                              showSearch: "",
                              optionFilterProp: "children",
                              options: _vm.legalpersonOptions,
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["legalperson"],
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.legalpersonId,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "legalpersonId", $$v)
                              },
                              expression: "queryParam.legalpersonId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["businessGroupName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "businessGroupId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseInput"] +
                                  _vm.language["businessGroupName"],
                                backDepart: true,
                                treeOpera: true
                              },
                              on: { change: _vm.backDepartGroup },
                              model: {
                                value: _vm.queryParam.businessGroupId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.queryParam,
                                    "businessGroupId",
                                    $$v
                                  )
                                },
                                expression: "queryParam.businessGroupId"
                              }
                            },
                            [
                              _c("a-icon", {
                                attrs: { slot: "suffixIcon", type: "gold" },
                                slot: "suffixIcon"
                              }),
                              _vm._l(_vm.groupDepartOptions, function(d) {
                                return _c(
                                  "a-select-option",
                                  { key: d.id, attrs: { value: d.id } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(d.departName) +
                                        "\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["businessUnitName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "businessUnitId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseInput"] +
                                  _vm.language["businessUnitName"],
                                backDepart: true,
                                treeOpera: true
                              },
                              on: { change: _vm.backDepartUnit },
                              model: {
                                value: _vm.queryParam.businessUnitId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.queryParam,
                                    "businessUnitId",
                                    $$v
                                  )
                                },
                                expression: "queryParam.businessUnitId"
                              }
                            },
                            [
                              _c("a-icon", {
                                attrs: { slot: "suffixIcon", type: "gold" },
                                slot: "suffixIcon"
                              }),
                              _vm._l(_vm.nextDepartOptions, function(d) {
                                return _c(
                                  "a-select-option",
                                  { key: d.id, attrs: { value: d.id } },
                                  [
                                    _vm._v(
                                      "\n                 " +
                                        _vm._s(d.departName) +
                                        "\n               "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["dangerType"] } },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["dangerType"],
                              dictCode: "ep_danger_type",
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.dangerType,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "dangerType", $$v)
                              },
                              expression: "queryParam.dangerType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 10, lg: 11, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["inspectTime"] } },
                        [
                          _c("j-date", {
                            staticClass: "query-group-cust",
                            attrs: {
                              placeholder:
                                _vm.language["common.chooseStartDate"]
                            },
                            model: {
                              value: _vm.queryParam.startTime,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "startTime", $$v)
                              },
                              expression: "queryParam.startTime"
                            }
                          }),
                          _c("span", { staticClass: "query-group-split-cust" }),
                          _c("j-date", {
                            staticClass: "query-group-cust",
                            attrs: {
                              placeholder: _vm.language["common.chooseEndDate"]
                            },
                            model: {
                              value: _vm.queryParam.endTime,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "endTime", $$v)
                              },
                              expression: "queryParam.endTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQueryCus }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchResetCus }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: { type: "primary", icon: "download" },
                      on: {
                        click: function($event) {
                          return _vm.handleExportXls("隱患類型分析表")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.language["common.exportButton"]))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: _vm.language["list.info.title"] } },
            [
              _c("div", [
                _c(
                  "table",
                  {
                    ref: "table",
                    staticClass: "j-table-force-nowrap",
                    staticStyle: { width: "100%", border: "1px solid #e8e8e8" },
                    attrs: {
                      size: "middle",
                      rowKey: "id",
                      scroll: { x: true },
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: _vm.ipagination,
                      loading: _vm.loading
                    },
                    on: { change: _vm.handleTableChange }
                  },
                  [
                    _c("colgroup", [
                      _c("col", {
                        staticStyle: { width: "60px", "min-width": "60px" }
                      }),
                      _c("col"),
                      _c("col"),
                      _c("col"),
                      _c("col"),
                      _c("col"),
                      _c("col"),
                      _c("col"),
                      _c("col")
                    ]),
                    _c("thead", { staticClass: "ant-table-thead" }, [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            key: "rowIndex",
                            staticClass:
                              "ant-table-align-center ant-table-row-cell-break-word",
                            staticStyle: { "text-align": "center" },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("#")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            key: "factoryName",
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v(_vm._s(_vm.language["factory"]))]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            key: "personName",
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.language["legalperson"])
                                      )
                                    ]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            key: "businessGroupName",
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["businessGroupName"]
                                        )
                                      )
                                    ]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            key: "businessUnitName",
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.language["businessUnitName"])
                                      )
                                    ]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            key: "dangerType",
                            staticClass: "ant-table-align-center",
                            staticStyle: {
                              "text-align": "center",
                              "border-bottom": "1px solid #e8e8e8"
                            },
                            attrs: { colspan: "11" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v(_vm._s(_vm.language["dangerType"]))]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass:
                              "ant-table-align-center ant-table-row-cell-last",
                            staticStyle: { "text-align": "center" },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v(_vm._s(_vm.language["totalSum"]))]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("MF")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("TW")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("TA")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("TN")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("TS")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("TR")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("TH")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("DW")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("DA")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("EO")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "ant-table-align-center",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "ant-table-header-column" },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "ant-table-column-title" },
                                    [_vm._v("EM")]
                                  ),
                                  _c("span", {
                                    staticClass: "ant-table-column-sorter"
                                  })
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "ant-table-tbody" },
                      [
                        _vm._l(_vm.dataSource, function(item, index) {
                          return _c(
                            "tr",
                            {
                              staticClass: "ant-table-row ant-table-row-level-0"
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(index + 1))]
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [_vm._v(_vm._s(item.factoryName))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(item.legalpersonName))]
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [_vm._v(_vm._s(item.businessGroupName))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(item.businessUnitName))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "MF")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "TW")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "TA")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "TN")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "TS")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "TR")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "TH")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "DW")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "DA")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "EO")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(_vm.getDangerSum(item, "EM")))]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "ant-table-row-cell-break-word",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v(_vm._s(item.dangerTypeNum))]
                              )
                            ]
                          )
                        }),
                        _c(
                          "tr",
                          {
                            staticClass: "ant-table-row ant-table-row-level-0"
                          },
                          [
                            _c("td", {
                              staticClass: "ant-table-row-cell-break-word",
                              staticStyle: { "text-align": "center" }
                            }),
                            _c(
                              "td",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { colspan: "4" }
                              },
                              [_vm._v(_vm._s(_vm.language["totalSum"]))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.MF))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.TW))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.TA))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.TN))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.TS))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.TR))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.TH))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.DW))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.DA))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.EO))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.EM))]
                            ),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(_vm._s(_vm.total.sumTotal))]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]
                )
              ])
            ]
          ),
          _c(
            "a-tab-pane",
            { key: "2", attrs: { tab: _vm.language["histogram"] } },
            [
              _c(
                "div",
                { staticStyle: { "overflow-x": "scroll" } },
                [
                  _c(
                    "v-chart",
                    {
                      attrs: {
                        extend: _vm.chartExtend,
                        height: _vm.height,
                        width: "2200",
                        data: _vm.data
                      }
                    },
                    [
                      _c("v-tooltip", { staticStyle: { width: "200px" } }),
                      _c("v-axis"),
                      _c("v-legend", { staticStyle: { width: "200px" } }),
                      _c("v-stack-bar", {
                        attrs: { position: "事業處*隱患數量", color: "name" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }